import ViewFactory from '@/Factories/ViewFactory';
import TwoFactorTokenDialogWindow from '@/Components/TwoFaktorAuth/TokenDialog/TwoFactorTokenDialogWindow';
import TwoFactorTokenDialogWindowViewModel from '@/Components/TwoFaktorAuth/TokenDialog/TwoFactorTokenDialogWindowViewModel';
import ComponentManager from '@/Management/ComponentManager';
import {IViewFactoryConstructorParameter} from '#/CoreFrameInterfaces';
import Utilities from '@/Utility/Utilities';

interface ITwoFactorTokenDialogViewFactoryConstructorParameter extends IViewFactoryConstructorParameter {
    shouldCleanRegion?: boolean;
    infoTextErgName?: string;
    buttonErgname?: string;
    username?: string;
    onOpen?: () => void;
    onClose?: () => void;
    onSubmit?: (token: string) => JQueryPromise<boolean>;
}

export default class TwoFactorTokenDialogViewFactory extends ViewFactory {
    private TwoFactorTokenDialogWindow = ComponentManager.getControl<typeof TwoFactorTokenDialogWindow>('TwoFactorTokenDialogWindow');
    private TwoFactorTokenDialogWindowViewModel = ComponentManager.getViewModel<typeof TwoFactorTokenDialogWindowViewModel>('TwoFactorTokenDialogWindow');

    public window: TwoFactorTokenDialogWindow;
    public viewModel: TwoFactorTokenDialogWindowViewModel;

    private shouldCleanRegion: boolean;
    private infoTextErgName: string;
    private buttonErgname: string;
    private username: string;
    private onOpen: () => void;
    private onClose: () => void;
    private onSubmit: (token: string) => JQueryPromise<boolean>;

    constructor(params: ITwoFactorTokenDialogViewFactoryConstructorParameter) {
        super(params);

        this.shouldCleanRegion = this.paramOrDefault(params.shouldCleanRegion, true);
        this.infoTextErgName = this.paramOrDefault(params.infoTextErgName, 'TWO_FA.TOKEN_INFO');
        this.buttonErgname = this.paramOrDefault(params.buttonErgname, 'DO_LOGIN');
        this.username = this.paramOrDefault(params.username, '');
        this.onOpen = this.handlerOrDefault(params.onOpen);
        this.onClose = this.handlerOrDefault(params.onClose);
        this.onSubmit = this.handlerOrDefault(params.onSubmit, () => Utilities.resolveImmediately(true));
    }

    public getRegion(): string {
        return 'Modal';
    }

    public shouldReplaceRegion(): boolean {
        return this.shouldCleanRegion;
    }

    public getView(): JQuery<HTMLElement> {
        if (this.viewModel == null) {
            this.viewModel = this.createViewModel();
        }

        if (this.window == null) {
            this.window = this.createControl(this.viewModel);
        }

        const tuple = this.window.getTuple();
        return tuple.control;
    }

    private createViewModel(): TwoFactorTokenDialogWindowViewModel {
        const windowSize = this.getWindowSize();
        return new this.TwoFactorTokenDialogWindowViewModel({
            isLoginWindow: true,
            centerOnWindowResize: true,
            width: windowSize.width,
            height: windowSize.height,
            onOpen: this.onOpen,
            onClose: this.onClose,
            onSubmit: this.onSubmit,
            username: this.username,
            locator: 'dialog.2fa',
            infoTextErgName: this.infoTextErgName,
            buttonErgname: this.buttonErgname
        });
    }

    protected getWindowSize(): { width: number, height: number } {
        return { width: 480, height: 310 };
    }

    private createControl(viewModel: TwoFactorTokenDialogWindowViewModel): TwoFactorTokenDialogWindow {
        return new this.TwoFactorTokenDialogWindow(viewModel);
    }
}

ComponentManager.setFactory('TwoFactorTokenDialogView', TwoFactorTokenDialogViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');